@if (visible()) {
    <div class="ai-dialog-overlay" @dialogFade>
        <div
            class="ai-dialog"
            @dialogFade
            [ngStyle]="{
                width: width(),
                height: height(),
                minWidth: minWidth(),
                minHeight: minHeight(),
                maxWidth: maxWidth(),
                maxHeight: maxHeight(),
            }"
        >
            <div class="ai-dialog-container">
                <ng-container
                    *ngComponentOutlet="
                        component();
                        injector: compInjector;
                        inputs: inputs
                    "
                ></ng-container>
            </div>
        </div>
    </div>
}
